import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-7b4dc212")
const _hoisted_1 = { class: "chart-container" }
const _hoisted_2 = {
  key: 2,
  class: "no-data-box"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "No hay datos para mostrar", -1)
const _hoisted_4 = [
  _hoisted_3
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BrainSpinner = _resolveComponent("BrainSpinner")!
  const _component_Chart = _resolveComponent("Chart")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_BrainSpinner, { key: 0 }))
      : (_openBlock(), _createBlock(_component_Chart, {
          key: 1,
          type: "line",
          data: _ctx.chartData,
          options: _ctx.chartOptions
        }, null, 8, ["data", "options"])),
    (!_ctx.existsData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true)
  ]))
}